let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bAnZw")).then(() => parcelRequire('7Ne5e'));